export default "__VITE_ASSET__d7b64db4__"